import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const WorkersCompOverviewPage = lazy(() => import('../pages/workers-comp-overview/page'));
const WorkplaceInjuryTypesPage = lazy(() => import('../pages/workplace-injury-types/page'));
const WorkersCompAppealsPage = lazy(() => import('../pages/workers-compensation-appeals/page'));
const IndustrialInjuryPage = lazy(() => import('../pages/industrial-injury/page'));
const RepetitiveStrainPage = lazy(() => import('../pages/repetitive-strain/page'));
const PsychologicalInjuryPage = lazy(() => import('../pages/psychological-injury/page'));
const ServiceAreasPage = lazy(() => import('../pages/service-areas/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const CaseResultsPage = lazy(() => import('../pages/case-results/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/workers-compensation-overview',
    element: <WorkersCompOverviewPage />,
  },
  {
    path: '/workplace-injury-types',
    element: <WorkplaceInjuryTypesPage />,
  },
  {
    path: '/workers-compensation-appeals',
    element: <WorkersCompAppealsPage />,
  },
  {
    path: '/industrial-injury-lawyer',
    element: <IndustrialInjuryPage />,
  },
  {
    path: '/repetitive-strain-injury-lawyer',
    element: <RepetitiveStrainPage />,
  },
  {
    path: '/psychological-injury-lawyer',
    element: <PsychologicalInjuryPage />,
  },
  {
    path: '/service-areas',
    element: <ServiceAreasPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/case-results',
    element: <CaseResultsPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
